import { InjectionToken } from '@angular/core';

/**
 * Resolves the base route for a student record, or null when the current user or host app cannot
 * open one. Called during change detection, so it may read signals and react to async role loading.
 */
export type StudentRecordRouteResolver = () => string | null;

/**
 * Opt-in capability for the shared roster: when a host app provides this, the roster's Student ID
 * column renders as a link to `${route}/${studentId}`; otherwise it stays plain text.
 *
 * This is a provider rather than a component @Input on purpose. Only a host that actually has a
 * student record page should light the link up, and requiring a provider in the app's bootstrap
 * makes that a deliberate, centrally reviewed act — a stray template binding cannot enable it. The
 * schools app has no student record page and must not provide this.
 */
export const STUDENT_RECORD_ROUTE = new InjectionToken<StudentRecordRouteResolver>('StudentRecordRoute');
